// extracted by mini-css-extract-plugin
export default {"close":"FullSizeImageModal_close__0VBqp","heading-primary":"FullSizeImageModal_heading-primary__5U4FY"};